/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useState, useRef, useCallback, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { Row, Col, Image, Space } from "antd";
import { TextField } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Gsttable } from "./GSTTable";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../assets/images/icon_menus/Drop Up.svg";
import usePrevious from "../../../../Shared/components/Previous";
import managementActions from "../../../../Sales/Management/redux/actions";
import supplierActions from "../../../../Purchase/Management/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkComponentPermission } from "../../../../../helpers/utilities";
import actions from "../../redux/actions";
import moment from 'moment';
import dayjs from 'dayjs';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { getRequest } from '../../../../../helpers/axiosClient';


const GSTTransactions = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { customerDetails, loader } = useSelector(state => state.salesManagementReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { gstTransactionLoader } = useSelector(state => state.adminReportReducer);

    const [customerId, setCustomerId] = useState('');
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const [picker, setPicker] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dateValue, setDateValue] = useState([null, null]);
    const [checkLoader, setCheckLoader] = useState(false);
    const dispatch = useDispatch();
    const timeoutRef = useRef(null);
    const [parties, setParties] = useState('');

    const limit = 25;
    const [skip, setSkip] = useState(0);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const { history } = props;

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(customerId, dateValue, sortBy, sortOrder);
    }

    const handleDates = (value, reset = false) => {
        setDateValue(value);
        if ((value[0] !== null && value[1] !== null) || reset) {
            dispatchFilter(customerId, value, sortBy, sortOrder);
        }
    }

    const handlePicker = (picker) => {
        setPicker(picker);
        setStartDate(null);
        setEndDate(null);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(customerId, dateValue, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(customerId, dateValue, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const handleChangeCustomer = (value) => {
        setCustomerId(value);
        dispatchFilter(value, dateValue, sortBy, sortOrder);
    }

    const dispatchFilter = (customerId, dateValue = [null, null], sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (customerId !== '') {
            let a = customerDetails && customerDetails.filter(function (el) { return el.id === parseInt(customerId) });
            if (a && a?.length !== 0) {
                filter['and'].push({ customerId: customerId });
            } else {
                filter['and'].push({ supplierId: customerId });
            }
        }

        if (search !== '') {
            or['or'].push({ transactionReference: search.trim() });
            or['or'].push({ type: { like: '%' + search.trim() + '%' } });
            or['or'].push({ originAmount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ invoiceNumber: { like: '%' + search.trim() + '%' } });
            or['or'].push({ netTaxRate: { like: '%' + search.trim() + '%' } });
            or['or'].push({ adjustedValue: { like: '%' + search.trim() + '%' } });
            or['or'].push({ calculatedValue: { like: '%' + search.trim() + '%' } });
        }

        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ date: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'gstTransaction',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('GST Detailed Transaction Report', history, 'Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadTasks = useCallback(() => {
        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: supplierActions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
                order: 'id  desc'
            }
        });
        dispatchFilter(customerId, dateValue, sortBy, sortOrder);
    });

    const customerObject = () => {
        let a = parties && parties.filter(function (el) { return el.id === parseInt(customerId) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (customerDetails && supplierDetails) {
            setParties([...customerDetails, ...supplierDetails])
        }
    }, [customerDetails, supplierDetails]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(customerId, dateValue, sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (customerId !== '') {
            let a = customerDetails && customerDetails.filter(function (el) { return el.id === parseInt(customerId) });
            if (a && a?.length !== 0) {
                filter['and'].push({ customerId: customerId });
            } else {
                filter['and'].push({ supplierId: customerId });
            }
        }

        if (search !== '') {
            or['or'].push({ transactionReference: search.trim() });
            or['or'].push({ type: { like: '%' + search.trim() + '%' } });
            or['or'].push({ originAmount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ invoiceNumber: { like: '%' + search.trim() + '%' } });
            or['or'].push({ netTaxRate: { like: '%' + search.trim() + '%' } });
            or['or'].push({ adjustedValue: { like: '%' + search.trim() + '%' } });
            or['or'].push({ calculatedValue: { like: '%' + search.trim() + '%' } });
        }

        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ date: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        filter['and'].push(or);
        dispatch({
            type: actions.GST_TRANSACTION_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'gstTransaction',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const loadToCheckGST = () => {
        try {
            setCheckLoader(true);
            let url = `${process.env.REACT_APP_API_URL}/customGSTSQLFunction`;
            let response = getRequest(url);
            response.then(payload => {
                setCheckLoader(false);
            }).catch(error => {
                // Handle any errors
                setCheckLoader(false);
            })
        } catch (error) {
            setCheckLoader(false);
        }
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'GST Detailed Transaction', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'All GST Transaction'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('GST Detailed Transaction Report', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Source, Orgin Amount & Net Rate'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('GST Detailed Transaction Report', 'Action', 'All Parties') &&
                                                <AutoCompleteComponent
                                                    customLabel={["All Parties "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={parties}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    parentValue={customerObject()}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleChangeCustomer(data);
                                                        }
                                                    }}
                                                    onChange={(data) => handleChangeCustomer(data.id)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('GST Detailed Transaction Report', 'Action', 'Transaction Date') &&
                                                <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                                    <Row>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                            <NavLink to={'#'} onClick={() => handlePicker(!picker)} className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                                                Transaction Date <Image
                                                                    src={picker ? DropUp : DropDown}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        </Col>
                                                        {
                                                            picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={startDate}
                                                                            label="From Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                },
                                                                                //inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([moment(newValue).format("YYYY-MM-DD"), endDate]);
                                                                                setStartDate(newValue);
                                                                            }}
                                                                            renderInput={(params) => <TextField autoComplete='one-time-code' name={"formDate"} {...params} />}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={endDate}
                                                                            minDate={new Date(startDate)}
                                                                            label="To Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,

                                                                                },
                                                                                //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([startDate, moment(newValue).format("YYYY-MM-DD")]);
                                                                                setEndDate(newValue);
                                                                            }}
                                                                            renderInput={(params) => <TextField autoComplete='one-time-code' name={"toDate"} {...params} />}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </div>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('GST Detailed Transaction Report', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('GSTTransaction'); }}
                                                    className={clsx(classes.customLink, { ['three_loader']: gstTransactionLoader })}>
                                                    {
                                                        !gstTransactionLoader && <><Image
                                                            src={ExportIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage)}
                                                        /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span></>
                                                    }
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('GST Detailed Transaction Report', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadToCheckGST(); }}
                                                    className={clsx(classes.customLink, { ['three_loader']: checkLoader })}>
                                                    {
                                                        !checkLoader && <><Image
                                                            src={ExportIcon}
                                                            preview={false}
                                                            className={clsx(classes.antImage)}
                                                        /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Check GST</span></>
                                                    }
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('GST Detailed Transaction Report', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <Gsttable
                                customerId={customerId}
                                search={search}
                                dateValue={dateValue}
                                loadTasks={() => dispatchFilter(customerId, dateValue, sortBy, sortOrder)}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                loadMoreTask={() => loadMoreTask()}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'GSTTransaction'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerDetails}
                loadTasks={() => { dispatchFilter(customerId, dateValue, sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}

export default GSTTransactions 